import React from 'react';
import { createComponent } from '@lit/react';
import { IxMenuAnchor as LitComp } from '../IxMenuAnchor.js';

customElements.define('ix-menu-anchor', LitComp);

export const IxMenuAnchor = createComponent({
  tagName: 'ix-menu-anchor-react',
  elementClass: LitComp,
  react: React,
});
